import Content from '../content-interface'

export default class ContractReOpenHistory implements Content {
  date: string;

  description: string;

  constructor(obj: any = {}) {
    this.date = obj.date || '';
    this.description = obj.description || '';
  }

  public static of(obj: any = {}): ContractReOpenHistory {
    return new ContractReOpenHistory(obj);
  }
}
